import { render, staticRenderFns } from "./activeConfigurationList.vue?vue&type=template&id=1f48b1b5"
import script from "./activeConfigurationList.vue?vue&type=script&lang=js"
export * from "./activeConfigurationList.vue?vue&type=script&lang=js"
import style0 from "./activeConfigurationList.vue?vue&type=style&index=0&id=1f48b1b5&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports